module.exports = __webpack_public_path__ + "img/batea-mobile.d1f365fd.png";